import { pluralize } from "utils/StringUtil";
import { CampaignType } from 'config/CustomEnums'

export function getDisplayQuantityWithLimitInfo(item, config) {
    if (!item) {
        return "-";
    }
    const {
        rewardedQuantityField,
        typeField,
        addTypeValue,
        initialValueKeyInJson,
        unit
    } = config;

    const rewardedQuantity = parseInt(item[rewardedQuantityField]) || 0;
    const reachedLimit = item.reachLimit;
    const limitedInfoStr = item.reachLimitInfo;
    const isAdd = item[typeField] === addTypeValue;
    const prefix = isAdd ? "+" : "-";
    const hasUndistributedRewards = isAdd && reachedLimit;

    if (!hasUndistributedRewards) {
        return `${prefix} ${rewardedQuantity} ${unit}(s)`;
    }

    try {
        const limitedInfo = JSON.parse(limitedInfoStr);
        const initialValue = parseInt(limitedInfo[initialValueKeyInJson]) || 0;
        const limitInfoType = limitedInfo?.limit_info_type;
        if (limitInfoType !== config.limitTypeValue) {
            return `${prefix} ${rewardedQuantity} ${unit}(s)`;
        }

        const diff = initialValue - rewardedQuantity;
        const suffix = pluralize(diff, unit);
        const notGivenInfo = `(${diff} ${suffix} are not given)`;
        return `${prefix} ${rewardedQuantity} ${unit}(s) ${notGivenInfo}`;
    } catch (error) {
        console.log("error", error);
        return `${prefix} ${rewardedQuantity} ${unit}(s)`;
    }
}

export const getCampaignDisplayName = (campaign) => {
  if (!campaign?.pk) {
    return "-"
  }
  return `[ID: ${campaign.pk}]${campaign.name}`
}

export const getCampaignLink = (campaign) => {
    if (!campaign?.pk) {
    return null
  }
  const campaignType = campaign.type
  let campaignPath = 'campaigns'
  if (campaignType === CampaignType.stampCampaign) {
    campaignPath = 'stamp_campaigns'
  } else if (campaignType === CampaignType.ticketCampaign){
    campaignPath = 'events'
  }
  return `/${campaignPath}/${campaign.pk}/`
}